import PropTypes from "prop-types"
import React from "react"

import ApplicationComponent from "./ApplicationComponent"

class FavoriteButton extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = {
      isFavorite: this.props.isFavorite,
      loading: false,
      hover: false,
    }
    this.handleToggleFavorite = this.handleToggleFavorite.bind(this)
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.handleAmplitude = this.handleAmplitude.bind(this)
  }

  onMouseEnter() {
    this.setState({ hover: true })
  }

  onMouseLeave() {
    this.setState({ hover: false })
  }

  handleAmplitude() {
    if (this.props.experienceName) {
      const heartPressedExperiences = [
        "destination_detail",
        "explore_collection",
        "search",
      ]
      if (heartPressedExperiences.includes(this.props.experienceName)) {
        Amplitude.trackEvent(`${this.props.experienceName}:heart_pressed`, {
          experience_name: this.props.experienceName,
          marina_id: this.props.mcomId,
          marina_name: this.props.marinaName,
          heart_state: this.state.isFavorite,
          visible_form: this.props.visibleForm,
        })
      }
    }
  }

  handleToggleFavorite(event) {
    event.stopPropagation()
    event.preventDefault()
    this.setState({ loading: true })
    $.ajax({
      url: DockwaConfig.BASE_URL + "/account/favorites",
      data: { marina_id: this.props.marinaId },
      type: this.state.isFavorite ? "DELETE" : "POST",
      dataType: "json",
      success: (_) => {
        this.setState({ loading: false, isFavorite: !this.state.isFavorite })
        this.handleAmplitude()
      },
      error: (error) => {
        if (error.status === 404) {
          // favorite doesn't exist; reset the button to the correct state
          this.setState({ loading: false, isFavorite: false })
        } else if (error.status === 401) {
          // not logged in
          window.location.href = error.responseJSON.redirect_to
        } else {
          this.setState({ loading: false })
        }
      },
    })
  }

  labelText() {
    if (this.state.loading) {
      return "Saving..."
    }
    if (this.state.isFavorite) {
      return this.state.hover ? "Remove" : "Favorited"
    } else {
      return "Favorite"
    }
  }

  renderIcon() {
    if (this.state.loading) {
      return (
        <i
          className="fa-solid fa-spinner-third fa-spin"
          style={{ height: "auto" }}
        />
      )
    } else {
      if (this.state.isFavorite && this.state.hover) return

      return (
        <i
          className={
            this.state.isFavorite ? "fa-solid fa-heart" : "fa-kit fa-heart-btm"
          }
          style={{ height: "auto", fontSize: 16 }}
        />
      )
    }
  }

  renderCompactIcon() {
    if (this.state.loading) {
      return (
        <i
          className="fa-solid fa-spinner-third fa-spin rounded-full p-1.5"
          style={{ height: "auto" }}
        />
      )
    }

    const baseClass = `${
      this.state.isFavorite ? "fa-solid" : "fa-kit"
    } font-bold text-lg`

    const iconType = this.state.isFavorite ? "fa-heart" : "fa-heart-btm"

    let textColor
    if (this.state.isFavorite) {
      textColor = this.state.hover ? "text-red-500" : "text-red-600"
    } else {
      if (this.state.hover) {
        textColor = "text-red-600"
      } else {
        textColor = this.props.imageOverlay ? "text-white" : "text-gray-600"
      }
    }

    const className = `${baseClass} ${iconType} ${textColor}`

    return <i className={className} />
  }

  render() {
    if (this.props.compact) {
      return (
        <div
          className="bg-transparent"
          onClick={(event) => this.handleToggleFavorite(event)}
          aria-pressed={!!this.state.isFavorite}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        >
          <span className="sr-only">Favorite Button</span>
          {this.renderCompactIcon()}
        </div>
      )
    } else {
      return (
        <button
          type="button"
          className={`btn ${
            this.state.isFavorite ? "btn-primary" : "btn-secondary"
          }`}
          style={{ minWidth: 125 }}
          onClick={this.handleToggleFavorite}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        >
          {this.renderIcon()}
          <span className="ml-2">{this.labelText()}</span>
        </button>
      )
    }
  }
}

FavoriteButton.propTypes = {
  marinaId: PropTypes.string.isRequired,
  marinaName: PropTypes.string.isRequired,
  mcomId: PropTypes.string.isRequired,
  isFavorite: PropTypes.bool.isRequired,
  experienceName: PropTypes.string,
  visibleForm: PropTypes.string,
  compact: PropTypes.bool,
  imageOverlay: PropTypes.bool,
}

export default FavoriteButton
